// extracted by mini-css-extract-plugin
export default {"wrapper":"styles-module__wrapper__dbb34b6047d7ee4a7759"};